import { render, staticRenderFns } from "./upgradeFiles.vue?vue&type=template&id=1c401423"
import script from "./upgradeFiles.vue?vue&type=script&lang=js"
export * from "./upgradeFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports